import { render, staticRenderFns } from "./OrderHistories.vue?vue&type=template&id=2b03bb7c&"
import script from "./OrderHistories.vue?vue&type=script&lang=js&"
export * from "./OrderHistories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports